// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gQ1H","field":"styles_field__16rcw","fieldCol":"styles_fieldCol__37g-e","diffCol":"styles_diffCol__2XuTH","diff":"styles_diff__dzyCO"};